import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  Creators as GenerationActions,
  Types as GenerationTypes,
} from 'store/ducks/Generation';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* listGeneration({ payload }) {
  try {
    const { status, data } = yield call(api.get, '/generations', {
      params: payload,
    });
    if (status === 200) {
      yield put(GenerationActions.getGenerationSuccess(data));
    } else {
      Sentry.captureMessage('listGeneration failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(GenerationActions.getGenerationError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(GenerationActions.getGenerationError());
  }
}

function* listGenerationWatcher() {
  yield takeLatest(GenerationTypes.GET_GENERATION, listGeneration);
}

export default function* rootSaga() {
  yield all([fork(listGenerationWatcher)]);
}
